// @ts-nocheck
import React from "react";
import { injectIntl } from "react-intl";
import moment from "moment";
import styled from "@emotion/styled";
import { Popup } from "react-leaflet";

import ParkStatisticsActioner from "services/parkStatistics/actioner";
import AvailableParkingUtils from "services/availableParking/utils";
import Abilities from "services/permissions/abilities";
import CommonUtils from "services/common/utils";
import Button from "./Button";
import { connect } from "react-redux";

const Container = styled.div`
  padding: 10px;
`;
const BoldContainer = styled.div`
  font-weight: bold;
`;
const ItalicContainer = styled.div`
  font-style: italic;
`;

const LockButtonContainer = styled.div`
  text-align: right;
  padding-top: 10px;
`;

class MapPopup extends React.Component {
  componentDidUpdate = (previousProps) => {
    const { isOpen } = this.props;
    if (previousProps.isOpen && !isOpen) {
      this.closePopup();
    }
  };

  renderAreaType = () => {
    const { intl, areaType } = this.props;
    if (!areaType || !Abilities.ability.can("read", "map.areaType"))
      return null;

    return (
      <div>{`${
        intl.messages["parkStatisticsScene.map.popup.park"]
      } ${intl.messages[`area.type.${areaType}`].toLowerCase()}`}</div>
    );
  };

  renderType = () => {
    const { intl, type } = this.props;
    if (!type || !Abilities.ability.can("read", "map.areaType")) return null;

    return (
      <div>{`${intl.messages["parkStatisticsScene.map.popup.type"]} ${
        intl.messages[`area.type.${type}`]
      }`}</div>
    );
  };

  renderArrivalTime = () => {
    const { intl, arrivalTime } = this.props;
    if (!arrivalTime || !Abilities.ability.can("read", "map.arrivalTime"))
      return null;

    return (
      <div>{`${
        intl.messages["parkStatisticsScene.map.popup.arrival"]
      } ${CommonUtils.formatTime(arrivalTime)}`}</div>
    );
  };

  renderLeavingTime = () => {
    const { intl, leavingTime } = this.props;
    if (!Abilities.ability.can("read", "map.leavingTime")) return null;

    if (!leavingTime) {
      return (
        <ItalicContainer>
          {intl.messages["parkStatisticsScene.map.popup.stillParked"]}
        </ItalicContainer>
      );
    }

    return (
      <div>{`${
        intl.messages["parkStatisticsScene.map.popup.leaving"]
      } ${CommonUtils.formatTime(leavingTime)}`}</div>
    );
  };

  renderAvailableFrom = () => {
    const { intl, availableFrom } = this.props;
    if (!Abilities.ability.can("read", "map.availableFrom")) return null;

    return (
      <div>{`${
        intl.messages["parkStatisticsScene.map.popup.since"]
      } ${CommonUtils.formatTime(availableFrom)}`}</div>
    );
  };

  renderAvailableTo = () => {
    const { intl, availableTo } = this.props;
    if (!Abilities.ability.can("read", "map.availableTo")) return null;

    if (!availableTo)
      return (
        <ItalicContainer>
          {intl.messages["parkStatisticsScene.map.popup.stillAvailable"]}
        </ItalicContainer>
      );

    return (
      <div>{`${
        intl.messages["parkStatisticsScene.map.popup.availableTo"]
      } ${CommonUtils.formatTime(availableTo)}`}</div>
    );
  };

  renderTotalDuration = () => {
    const { intl, leavingTime, totalDuration } = this.props;
    if (
      (totalDuration !== 0 && !totalDuration) ||
      !Abilities.ability.can("read", "map.totalDuration")
    ) {
      return null;
    }

    const tradKey = leavingTime
      ? `parkStatisticsScene.map.popup.totalDurationDuring`
      : `parkStatisticsScene.map.popup.totalDurationSince`;

    return (
      <div>{`${intl.messages[tradKey]} ${CommonUtils.formatDuration(
        totalDuration
      )}`}</div>
    );
  };

  renderSpotTotalDuration = () => {
    const { intl, availableTo, totalDuration } = this.props;
    if (
      (totalDuration !== 0 && !totalDuration) ||
      !Abilities.ability.can("read", "map.totalDuration")
    ) {
      return null;
    }

    const tradKey = availableTo
      ? `parkStatisticsScene.map.popup.spotTotalDurationDuring`
      : `parkStatisticsScene.map.popup.spotTotalDurationSince`;

    return (
      <div>{`${intl.messages[tradKey]} ${CommonUtils.formatDuration(
        totalDuration
      )}`}</div>
    );
  };

  renderSize = () => {
    const { intl, size } = this.props;
    if (!size || !Abilities.ability.can("read", "map.size")) return null;

    return (
      <div>{`${intl.messages["parkStatisticsScene.map.popup.size"]} ${size}m`}</div>
    );
  };

  openPopup = () => {
    const { center } = this.props;
    if (this.map && this.leafletElement && this.map.openPopup) {
      this.map.openPopup(this.leafletElement, center);
    }
  };

  closePopup = () => this.map?.closePopup && this.map.closePopup();

  renderLock() {
    const { canBeLocked, isLocked, intl, lockSpace, uid } = this.props;
    if (!Abilities.ability.can("read", "map.lockSpaces") || !canBeLocked)
      return null;

    if (!isLocked) {
      return (
        <LockButtonContainer>
          <Button
            label={intl.messages["parkStatisticsScene.map.popup.lock"]}
            fullWidth={false}
            onClick={() => {
              lockSpace(uid, true);
              this.closePopup();
            }}
          />
        </LockButtonContainer>
      );
    }

    return (
      <LockButtonContainer>
        <Button
          label={intl.messages["parkStatisticsScene.map.popup.unlock"]}
          fullWidth={false}
          onClick={() => {
            lockSpace(uid, false);
            this.closePopup();
          }}
        />
      </LockButtonContainer>
    );
  }

  renderLockedDuration() {
    const { intl, isLocked, canBeLocked } = this.props;
    if (
      !Abilities.ability.can("read", "map.lockSpaces") ||
      !canBeLocked ||
      !isLocked
    )
      return null;

    const date = moment(isLocked);
    const now = moment();

    return (
      <>
        <hr />
        <BoldContainer>
          {`${
            intl.messages["parkStatisticsScene.map.popup.locked"]
          } ${date.format("D MMMM - LT")}`}
        </BoldContainer>
        {`${
          intl.messages["parkStatisticsScene.map.popup.lockedDuration"]
        } ${CommonUtils.formatDuration(now.diff(date, "seconds"))}`}
      </>
    );
  }

  renderSpotContent() {
    return (
      <>
        {this.renderAvailableFrom()} {/* Depuis le 5 novembre - 08:21 */}
        {this.renderAvailableTo()} {/* Départ le 5 novembre - 08:21 */}
        {this.renderSpotTotalDuration()} {/* Stationné depuis/pendant 6h */}
        {this.renderAreaType()} {/* Type : Taxi */}
        {this.renderType()} {/* Type : Taxi */}
        {this.renderLockedDuration()}
        {this.renderLock()}
      </>
    );
  }

  renderCarContent() {
    return (
      <>
        {this.renderArrivalTime()} {/* Arrivée le 5 novembre - 08:21 */}
        {this.renderLeavingTime()} {/* Départ le 5 novembre - 08:21 */}
        {this.renderTotalDuration()} {/* Stationné depuis/pendant 6h */}
        {this.renderAreaType()} {/* Type : Taxi */}
        {this.renderType()} {/* Type : Taxi */}
        {this.renderLockedDuration()}
        {this.renderLock()}
      </>
    );
  }

  render() {
    const { isOpen, layerType, onClose, onOpen } = this.props;

    return (
      <Popup
        autoPan={false}
        onClose={onClose}
        onOpen={onOpen}
        ref={(ref) => {
          this.map = ref?.props?.leaflet?.map;
          this.leafletElement = ref?.leafletElement;
          isOpen && this.openPopup();
        }}
      >
        <Container>
          {AvailableParkingUtils.isSpot(layerType)
            ? this.renderSpotContent()
            : this.renderCarContent()}
        </Container>
      </Popup>
    );
  }
}

MapPopup.defaultProps = {
  isOpen: false,
};

const mapDispatchToProps = (dispatch) => ({
  lockSpace: (uid, isLocked) =>
    dispatch(ParkStatisticsActioner.lockSpace(uid, isLocked)),
});

export default connect(null, mapDispatchToProps)(injectIntl(MapPopup));
